import { SvgGradients } from "types/enums";
import * as theme from "utils/theme";

export const Gradients = () => {
  return (
    <defs>
      <linearGradient id={SvgGradients.Blue} gradientTransform="rotate(90)">
        <stop offset="0%" stopColor={theme.blueGradient[0]} />
        <stop offset="100%" stopColor={theme.blueGradient[1]} />
      </linearGradient>
      <linearGradient id={SvgGradients.Red} gradientTransform="rotate(90)">
        <stop offset="0%" stopColor={theme.redGradient[0]} />
        <stop offset="100%" stopColor={theme.redGradient[1]} />
      </linearGradient>
      <linearGradient id={SvgGradients.RedFaded} gradientTransform="rotate(90)">
        <stop offset="0%" stopColor={theme.redFadedGradient[0]} />
        <stop offset="100%" stopColor={theme.redFadedGradient[1]} />
      </linearGradient>
      <linearGradient id={SvgGradients.Green} gradientTransform="rotate(90)">
        <stop offset="0%" stopColor={theme.greenGradient[0]} />
        <stop offset="100%" stopColor={theme.greenGradient[1]} />
      </linearGradient>
    </defs>
  );
};
